import PropTypes from 'prop-types';

export function WarningInfobox(props) {
	return <Infobox {...props} warning={true} />;
}

export default function Infobox({ children, warning = false, small = false }) {
	const props = {};
	const classes = ['infobox'];

	if (warning) {
		classes.push('infobox--warning');
	}

	if (small) {
		classes.push('infobox--small');
	}

	props.className = classes.join(' ');

	return <div {...props}>{children}</div>;
}

Infobox.propTypes = {
	children: PropTypes.node.isRequired,
	warning: PropTypes.bool,
	small: PropTypes.bool,
};
